<template>
    <div v-if="worker" class="worker-info">
        <h1>Nome: {{ worker.name }}</h1>
        <h2>Serviço: {{ service.name }}</h2>

        <div class="content">
            <form @submit.prevent="updateUser">
                <InputContent label="Nome" v-model="name" />
                <InputSelectContent label="Selecionar o serviço" :options="serviceOptions" v-model="selectedService" />
            </form>
        </div>

        <h2>Utilizadores Registados</h2>
        <TableComponent :columns="userCols" :elements="users" :destination="(worker) => '/'">
        </TableComponent>

    </div>
</template>

<script>
import InputContent from '@/components/inputs/Content.vue'
import InputSelectContent from '@/components/inputs/Select.vue'
import TableComponent from '@/components/Table.vue'


export default {
    name:'WorkersInfo',
    props: {
        id: {
            required: true
        },
    },

    components: {
        InputContent,
        InputSelectContent,
        TableComponent,
    },

    data() {
        return {
            name: "",
            loading: false,
            selectedService: "",
            userCols: [
                { text: this.$t('name'), attribute: 'name' },
                { text: this.$t('email'), attribute: 'email' },
            ],
        }
    },

    methods: {
        async updateUser() {
            this.loading = true;
            try {
                this.$store.dispatch('users/edit', { id: this.id, name: this.name })
            } catch (error) {
                console.log('Error updating user');
            }
        },
    },

    computed: {
        isworkerChanged() {
            if (this.worker == null) {
                return null
            }
            const workerName = this.name !== this.worker.name
            const workerRole = this.selected !== this.worker.role
            return workerName || workerRole
        },
        users() {
            return this.$store.getters['users/worker'](this.id);
        },
        worker() {
            return this.$store.getters['workers/id'](this.id)
        },
        userData() {
            return {
                id: this.id,
                name: this.name,
                role: this.selected,
            }
        },
        projects() {
            return this.$store.state.projects.all
        },
        service() {
            if (this.worker.service == null) {
                return { name: 'Nenhum serviço selecionado' }
            }
            return this.$store.getters['services/id'](this.worker.service)
        },
        serviceOptions() {
            let services = this.$store.state.services.all
            return services.map(service => {
                return { value: service.id, text: service.name }
            })
        },
    },

    watch: {
        selectedService() {
            this.$store.dispatch('workers/addService', {
                workerId: this.id,
                serviceId: this.selectedService,
            })
        },
        worker: {
            immediate: true,
            handler() {
                if (this.worker != null) {
                    this.name = this.worker.name
                    this.selected = this.worker.role
                    // this.selectedService = this.worker.service;
                }
            },
        }
    },

    async mounted() {
        this.$store.dispatch('workers/getAll')
        this.$store.dispatch('projects/getAll')
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.worker-info {

    .content {
        background-color: var(--sidebar-bg-color);
        padding: 20px;
        border: 1px solid none;
        border-radius: 10px;
        box-shadow: 0 3px 6px rgba(var(--black), .16), 0 3px 6px rgba(var(--black), .23);
    }
}
</style>
